<app-info-popup
  #infoModal
  [title]="'Meeting Not Logged'"
  [message]="
    'This meeting wasn’t logged in convverse.ai. It may have happened offline or the bot wasn’t granted access'
  "
  [confirmText]="'Got it'"
></app-info-popup>

<app-main-wrapper title="Past meetings">
  <app-email-modal
    #emailModal
    [meetingBotId]="meetingBotId"
    [emails]="selectedEmails"
  ></app-email-modal>
  <div>
    <div
      class="d-flex gap-2 mb-2 mr-3 meetings-toolbar"
      style="align-items: end; justify-content: space-between"
    >
      <p
        class="timezone-note"
        style="
          font-size: 0.75rem;
          color: #666;
          margin-top: -5px;
          margin-bottom: 10px;
        "
      >
        * All times displayed per your calendar time zone
      </p>
      <button
        type="button"
        (click)="toggleExpandCollapse()"
        class="expand-toggle-btn"
        [class.is-expanded]="allExpanded"
        [attr.aria-label]="allExpanded ? 'Collapse all meeting days' : 'Expand all meeting days'"
      >
        <span class="expand-toggle-icon-stack" aria-hidden="true">
          <i class="fas fa-expand expand-toggle-icon" [class.is-active]="!allExpanded"></i>
          <i class="fas fa-compress expand-toggle-icon" [class.is-active]="allExpanded"></i>
        </span>
        <span class="expand-toggle-label">{{ allExpanded ? 'Collapse all' : 'Expand all' }}</span>
      </button>
    </div>

    <div class="search-filter-row">
      <div class="search-box">
        <i class="fas fa-search"></i>
        <input
          type="text"
          class="search-input"
          placeholder="Search for keywords, participants, and more..."
          [(ngModel)]="draftSearch"
          (ngModelChange)="onSearchChange($event)"
        />
      </div>

      <!-- ── Date range filter (inline) ────────────────────────────── -->
      <div class="date-filter-inline">
        <div class="date-input-group">
          <input type="date" class="date-input-compact" [(ngModel)]="draftFrom" [max]="draftTo || ''" />
          <span class="date-separator">→</span>
          <input type="date" class="date-input-compact" [(ngModel)]="draftTo" [min]="draftFrom || ''" />
        </div>
        <button class="filter-apply-btn-compact" (click)="applyDateFilter()" [disabled]="!draftFrom && !draftTo" title="Apply date filter">
          Apply
        </button>
        <button class="filter-clear-btn-compact" *ngIf="isFilterActive" (click)="clearDateFilter()" title="Clear date filter">
          Clear
        </button>
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-2"
    >
    </div>
  </div>

  <div class="date-section" *ngFor="let item of allMeetings; let i = index">
    <div
      class="date-header d-flex justify-content-between align-items-center"
    >
      <div
        class="d-flex align-items-center gap-2"
        (click)="$event.stopPropagation()"
      >
        <span>{{ formatMeetingDate(item.date) }}</span>
      </div>
      <div class="date-header-actions">
        <button
          class="collapse-button"
          [class.is-open]="!isCollapsed(item.date)"
          (click)="toggleCollapse(item.date)"
          aria-label="Toggle collapse"
          title="Toggle collapse"
        >
          <i class="fas fa-chevron-down collapse-icon" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="meetings-list" *ngIf="!isCollapsed(item.date)">
      <ng-container *ngFor="let meeting of item.meetings">
        <div
          class="meeting-row"
          (click)="goToOpportunity(meeting)"
          [style.cursor]="meeting.opportunity_id ? 'pointer' : 'default'"
          [class.disabled]="!meeting.opportunity_id"
        >
          <div class="meeting-time">
            {{ getMeetingStartDisplay(meeting) }} -
            {{ getMeetingEndDisplay(meeting) }} <br />
            <span
              class="duration"
              *ngIf="getMeetingDurationLabel(meeting)"
              style="color: #000; display: block; text-align: center"
            >
              {{ getMeetingDurationLabel(meeting) }}
            </span>
          </div>
          <div class="meeting-details">
            <div class="meeting-title-row">
              <span class="opportunity-pill">
                <i class="fa-regular fa-user opportunity-pill__icon" aria-hidden="true"></i>
                <span class="opportunity-pill__label">{{ meeting.opportunity_name }}</span>
              </span>
              <div class="meeting-title">
                {{ meeting.meeting_title }}
              </div>
            </div>
            <div class="meeting-meta">
              <span class="speakers" *ngIf="meeting.distinct_speakers?.length">
                <i class="fa-solid fa-users"></i>
                {{ meeting.distinct_speakers.join(", ") }}
              </span>
            </div>
          </div>
          <div
            class="meeting-actions"
            (click)="emailMeetingPopup(meeting, $event)"
          >
            <i
              class="fas fa-envelope action-icon"
              title="Email meeting summary"
            ></i>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-bar" *ngIf="!isLoading && (currentPage > 1 || hasNextPage)">
    <button class="page-btn" (click)="goToPrevPage()" [disabled]="currentPage === 1">
      &lsaquo; Prev
    </button>
    <span class="page-indicator">Page {{ currentPage }}</span>
    <button class="page-btn" (click)="goToNextPage()" [disabled]="!hasNextPage">
      Next &rsaquo;
    </button>
  </div>

  <div class="pagination-loading" *ngIf="isLoading">
    Loading...
  </div>
</app-main-wrapper>
